enum AISuggestion {
    Conversation = "conversation",
    CustomViewCreation = "customViewCreation",
}

export default AISuggestion;

export enum AiSuggestionsTipsList {
    priority = "priority",
    summary = "summary",
    /* reply = 'reply', */
    todo = "todo",
    search = "search",
}

export enum AiSuggestionsCustomViewCreationList {
    teamProjectAlpha = "teamProjectAlpha",
    priorityClients = "priorityClients",
    deadlines = "deadlines",
    meetingInformation = "meetingInformation",
    budgetQuarterly = "budgetQuarterly",
    externalProviders = "externalProviders",
    technicalIssues = "technicalIssues",
    reportsStatistics = "reportsStatistics",
    humanResources = "humanResources",
}

export enum AiSuggestionsConversationList {
    // Email Search
    allWithAttachments = "allWithAttachments",
    unreadFromSender = "unreadFromSender",
    searchWithKeyword = "searchWithKeyword",
    betweenDates = "betweenDates",
    removeSpam = "removeSpam",
    markAsRead = "markAsRead",
    unprocessed = "unprocessed",
    clientFromDate = "clientFromDate",
    searchInAccount = "searchInAccount",

    // Agenda Creation
    createMeeting = "createMeeting",
    scheduleAppointment = "scheduleAppointment",
    planEvent = "planEvent",
    createReminder = "createReminder",
    scheduleTraining = "scheduleTraining",
    planLunch = "planLunch",
    organizePresentation = "organizePresentation",
    createInterview = "createInterview",

    // Agenda Consultation
    showPlanningFromTo = "showPlanningFromTo",
    showMeetingsToday = "showMeetingsToday",
    consultAgenda = "consultAgenda",
    checkAvailability = "checkAvailability",
    showEvents = "showEvents",
    showPlanning = "showPlanning",
    consultMeetings = "consultMeetings",
    checkAgenda = "checkAgenda",

    // Free Time Search
    findFreeTime = "findFreeTime",
    findHours = "findHours",
    identifyTimeSlots = "identifyTimeSlots",
    findFreeTimeTomorrow = "findFreeTimeTomorrow",
    findFreeTimeNextMonday = "findFreeTimeNextMonday",
    findHoursThisWeek = "findHoursThisWeek",
    findFreeTimeMorning = "findFreeTimeMorning",
    findFreeTimeToday = "findFreeTimeToday",
    identifyTimeSlotsToday = "identifyTimeSlotsToday",

    // General Chat
    explainEmailManagement = "explainEmailManagement",
    giveAdvice = "giveAdvice",
    conversationSummary = "conversationSummary",
    visibilityAdvices = "visibilityAdvices",
}
